export default "__VITE_ASSET__DoTk5k6x__"